(() => {
  const init = scope => scope.querySelectorAll('[data-pp-knowledge]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const input = root.querySelector('[data-knowledge-search]');
    const buttons = [...root.querySelectorAll('[data-knowledge-topic]')];
    const groups = [...root.querySelectorAll('[data-knowledge-group]')];
    const answers = [...root.querySelectorAll('[data-knowledge-answer]')];
    const status = root.querySelector('[data-knowledge-status]');
    const normalize = text => text.toLocaleLowerCase('nl').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const text = new Map(answers.map(answer => [answer, normalize(answer.textContent)]));
    let topic = 'all';
    root.querySelectorAll('[data-knowledge-controls]').forEach(el => {el.hidden = false;});
    const update = () => {
      const terms = normalize(input.value).trim().split(/\s+/).filter(Boolean);
      let count = 0;
      groups.forEach(group => {
        let visible = 0;
        group.querySelectorAll('[data-knowledge-answer]').forEach(answer => {
          const match = (topic === 'all' || topic === group.dataset.knowledgeGroup) && terms.every(term => text.get(answer).includes(term));
          answer.hidden = !match;
          if (match) { visible++; count++; }
        });
        group.hidden = visible === 0;
      });
      status.textContent = `${count} ${count === 1 ? status.dataset.one : status.dataset.label}`;
      root.querySelector('[data-knowledge-empty]').hidden = count > 0;
      buttons.forEach(button => button.setAttribute('aria-pressed',String(button.dataset.knowledgeTopic === topic)));
    };
    input.addEventListener('input',update);
    buttons.forEach(button => button.addEventListener('click',() => {topic = button.dataset.knowledgeTopic;update();}));
    root.querySelector('[data-knowledge-reset]').addEventListener('click',() => {input.value = '';topic = 'all';update();input.focus();});
    update();
    if (location.hash) {
      const match = answers.find(answer => '#'+answer.id === location.hash);
      if (match) match.open = true;
    }
  });
  if (window.ppKnowledgeInitialized) return;
  window.ppKnowledgeInitialized = true;
  init(document);
  document.addEventListener('shopify:section:load',event => init(event.target));
  document.addEventListener('shopify:block:select',event => {const answer = event.target.closest('[data-knowledge-answer]');if(answer) {answer.hidden=false;answer.closest('[data-knowledge-group]').hidden=false;answer.open=true;}});
})();
